import { render } from "./edit-salary.vue?vue&type=template&id=5784d7fa"
import script from "./edit-salary.vue?vue&type=script&lang=js"
export * from "./edit-salary.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__